import { render } from "./drafts-table.vue?vue&type=template&id=5a05676c"
import script from "./drafts-table.vue?vue&type=script&lang=js"
export * from "./drafts-table.vue?vue&type=script&lang=js"

import "./drafts-table.vue?vue&type=style&index=0&id=5a05676c&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__